(() => {
  if (!/\/policies\/shipping-policy\/?$/.test(window.location.pathname)) return;

  const body = document.querySelector('.shopify-policy__body');
  if (!body) return;

  const logo = [...body.querySelectorAll('img')].find((image) => {
    const source = `${image.currentSrc || ''} ${image.src || ''}`;
    return source.includes('zustellungdurch-dhl-webshop-logo') || source.includes('DHL_Deutsche_Post.png');
  });

  if (!logo) return;

  if (!body.querySelector('.arando-policy-carrier-heading')) {
    const heading = document.createElement('h3');
    heading.className = 'arando-policy-carrier-heading';
    heading.textContent = 'Versanddienstleister';
    logo.before(heading);
  }

  const logos = document.createElement('div');
  logos.className = 'arando-policy-carrier-logos';
  logos.innerHTML = `
    <span class="arando-policy-carrier-logo-card">
      <img src="https://cdn.shopify.com/s/files/1/0567/8225/8236/files/DHL.webp?v=1780252171" alt="DHL" loading="lazy">
    </span>
    <span class="arando-policy-carrier-logo-card">
      <img src="https://cdn.shopify.com/s/files/1/0567/8225/8236/files/Deutsche_Post.webp?v=1780252167" alt="Deutsche Post" loading="lazy">
    </span>
  `;
  logo.replaceWith(logos);
})();
